import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import { useLang } from '../context/LangContext';
import StatusBadge from '../components/StatusBadge';

export default function Dashboard() {
  const { t } = useLang();
  const [audits, setAudits]   = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/audits')
      .then(r => setAudits(r.data))
      .finally(() => setLoading(false));
  }, []);

  const open    = audits.filter(a => a.status !== 'closed');
  const recent  = audits.slice(0, 5);
  const clients = [...new Set(audits.map(a => a.client_name))].length;

  return (
    <>
      <div className="page-header">
        <h2>{t('dash_title')}</h2>
      </div>
      <div className="page-body">

        {/* Stats */}
        <div className="row g-3 mb-4">
          {[
            { value: open.length,   label: t('dash_open_audits') },
            { value: audits.length, label: t('nav_audits') },
            { value: clients,       label: t('dash_clients') },
          ].map((s, i) => (
            <div key={i} className="col-md-4">
              <div className="card text-center py-3">
                <div className="card-body py-2">
                  <div style={{ fontSize: 32, fontWeight: 700, color: '#2563eb' }}>{s.value}</div>
                  <div className="text-muted small">{s.label}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Recent audits */}
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <span className="fw-semibold">{t('dash_recent')}</span>
            <Link to="/audits" className="btn btn-sm btn-outline-secondary">{t('nav_audits')}</Link>
          </div>
          {loading ? (
            <div className="card-body text-center text-muted py-4">
              <div className="spinner-border spinner-border-sm me-2" />
              {t('loading')}
            </div>
          ) : recent.length === 0 ? (
            <div className="card-body text-center text-muted py-4">
              <Link to="/audits">{t('audit_new')}</Link>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover table-clickable mb-0">
                <thead className="table-light">
                  <tr>
                    <th>{t('audit_name')}</th>
                    <th>{t('audit_client')}</th>
                    <th>{t('audit_framework')}</th>
                    <th>{t('audit_status')}</th>
                    <th style={{ minWidth: 140 }}>{t('audit_progress')}</th>
                  </tr>
                </thead>
                <tbody>
                  {recent.map(a => {
                    const pct = a.total_controls > 0
                      ? Math.round((a.beoordeeld / a.total_controls) * 100) : 0;
                    return (
                      <tr key={a.id}>
                        <td>
                          <Link to={`/audits/${a.id}`} className="fw-medium text-decoration-none">{a.name}</Link>
                        </td>
                        <td>{a.client_name}</td>
                        <td className="text-muted">{a.framework_name}</td>
                        <td><StatusBadge status={a.status} /></td>
                        <td>
                          <div className="progress">
                            <div className="progress-bar" style={{ width: `${pct}%` }} />
                          </div>
                          <div className="text-muted-sm mt-1">{a.beoordeeld}/{a.total_controls} {t('assessed')}</div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>

      </div>
    </>
  );
}
